webpackJsonp([156649023640004],{

/***/ 1162:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0041_spectral_roc.jpg","type":"Unit","subtype":"Bird Illusion","cost":4,"ATK":4,"HP":5,"rules_text_1":"(Illusions die when ◎ by spells or abilities.)","rules_text_2":"Flying","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Spectral Roc","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Blue","spec":"Truth","bottom":"Tech II","rulings":[],"keywords":["Flying","Illusion"],"slug":"spectral_roc"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"spectral_roc","keywords":["Flying","Illusion"],"imageRegex":"/spectral_roc.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-spectral-roc-69d3bda9d6bbf889834e.js